export default "__VITE_ASSET__KOdopd2v__"